import * as React from 'react';
import { inject, observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import { translate } from './Translate';
import Icon from './Icon';

const Button = styled<any, any>('button') `
    ${propStyles};
    border: none;
    outline: none;
    cursor: pointer;
    transition: transform 160ms linear, color 160ms linear;
    transform: ${p => p['data-selected'] ? "rotate3d(0,1,0,180deg)" : "rotate3d(0,1,0,0deg)"};
`;

Button.defaultProps = {
    fontSize: "1.6em",
    color: "body",
    bgColor: "transparent",
    selected: {
        color: "primary",
    }
};

const StarIcon = styled<any, any>(Icon)``;

StarIcon.defaultProps = {
    height: "1em",
    width: "1em"
};

export const WatchListToggle: React.SFC<any> = ({ theme, translations, active, onClick, ...props }) => (
    <Button
        title={active ? translate(translations, 'Remove from Watch List') : translate(translations, 'Add to Watch List')}
        onClick={onClick}
        data-selected={active}
        {...props}
        {...theme.WatchListToggle}
    >
        {
            active ? <StarIcon fileName="WatchlistToggleIcon" /> : <StarIcon fileName="WatchlistToggleOutlineIcon" />
        }
    </Button>
);

export default inject('translations')(observer(withTheme(WatchListToggle))) as any;


// WEBPACK FOOTER //
// ./src/Components/WatchListToggle.tsx